import { apiMunzen } from '@/app/api/apiMunzen/apiMunzen';
import type { ApiResponse } from '@/common/types/api.interface';
import type { Auth } from '../types/auth.interface';
import type { RegisterForm } from '../types/registerForm.interface';
import type { ResetPasswordForm } from '../types/resetPasswordForm.interface';

/**
 * @author: Omar Sánchez Martinez
 * @since: 26/05/2025
 * @description: Inicia sesión
 */
export const loginService = async (email: string, password: string): Promise<Auth> => {
  const response = await apiMunzen.post('/users/login', { email, password });
  return response.data.data;
};

/**
 * @author: Omar Sánchez Martinez
 * @since: 26/05/2025
 * @description: Cierra sesión
 */
export const logoutService = async (): Promise<boolean> => {
  const response = await apiMunzen.get('/users/logout');
  return response.data.data.success;
};

/**
 * @author: Omar Sánchez Martinez
 * @since: 03/06/2025
 * @description: Registra un nuevo usuario
 */
export const registerService = async (data: RegisterForm): Promise<string> => {
  const registerData = {
    name: data.name,
    rfc: data.rfc,
    phone: data.phone,
    email: data.email,
    password: data.password,
  };
  const response = await apiMunzen.post('/new-client-pre-register', registerData);
  return response.data.data.new_client_token;
};

/**
 * @author: Omar Sánchez Martinez
 * @since: 17/06/2025
 * @description: Inicia sesión para un nuevo cliente usando su token
 */
export const loginNewClientService = async (token: string): Promise<Auth> => {
  const response = await apiMunzen.get(`/users/login/new-client/${token}`);
  return response.data.data;
};

/**
 * @author: Omar Sánchez Martinez
 * @since: 31/10/2025
 * @description: Verifica si un token de reset password existe y es válido
 */
export const validateResetPasswordTokenService = async (token: string): Promise<boolean> => {
  const response = await apiMunzen.get(`/users/reset-password/exist/${token}`);
  return response.data.data.success;
};

/**
 * @author: Omar Sánchez Martinez
 * @since: 31/10/2025
 * @description: Establece una nueva contraseña usando el token de reset y retorna los datos de autenticación
 */
export const setNewPasswordService = async (data: ResetPasswordForm): Promise<Auth> => {
  const response = await apiMunzen.post<ApiResponse<Auth>>('/users/reset-password/set', data);
  return response.data.data;
};
